import IntegrateMsgConfig from './IntegrateMsgConfig';
export default IntegrateMsgConfig;
